<div *ngIf="(vm$ | async) as vm" id="gift-checkout-modal-main">
    <div [@sidepanel] *ngIf="show" class="sidepanel">

        <div id="sidePanelBanner" style="display:inline-block; padding-top: 15px; padding-left:15px; right: 0">
            <a id="close-link" aria-label="Close" href="javascript:void(0)" class="closebtn" (click)="closeModal()">×</a>
        </div>

        <form id="gift-checkout-main-form-group" *ngIf="!makePaymentComplete" [formGroup]="formGroup">
            <div class="row">
                <h4 class="bold-header">Gift Checkout</h4>
            </div>

            <div class="row">
                <label class="section-header" for="amount-input">Amount</label>
            </div>

            <div class="row">
                <h4 style="display:contents; font-weight:600">$</h4>&nbsp;&nbsp;
                <input id="amount-input"
                       type="text"
                       class="form-control"
                       (keypress)="onKeyPressAmount($event)"
                       style="width:195px; display: inline-block;"
                       formControlName="amountInput" />
            </div>
            <div *ngIf="amountInput?.touched && amountInput?.errors">
                <cl-error-validation-message id="amount-validation-message-min"
                                             class="validation-block"
                                             *ngIf="amount < minAmount"
                                             message="Please enter an amount above or equal to {{minAmount | kendoNumber:'c'}} ">
                </cl-error-validation-message>
                <cl-error-validation-message id="amount-validation-message-max"
                                             class="validation-block"
                                             *ngIf="amount > maxAmount"
                                             message="Please enter an amount below or equal to {{maxAmount | kendoNumber:'c'}} ">
                </cl-error-validation-message>
            </div>
            <div class="row">
                <kendo-switch id="private-gift"
                              #privateGift
                              [onLabel]="'Yes'"
                              [offLabel]="'No'"
                              style="transform:scale(0.8); font-weight: bold;"
                              formControlName="privateGift">
                </kendo-switch>

                <label [for]="privateGift" style="display: inline-block">
                    Private Gift
                    <cl-tooltip [message]="'A Private Gift means that your name will not be shared with the student and instead be marked as a private gift.'"></cl-tooltip>
                </label>
            </div>

            <div formGroupName="contactInfo">

                <div class="row">
                    <label class="section-header">Contact Information</label>
                </div>

                <div class="row">
                    <label for="first-name">First Name</label>
                    <input id="first-name"
                           type="text"
                           class="full-row form-control"
                           formControlName="firstName" />
                </div>
                <cl-error-validation-message id="first-name-validation-message"
                                             class="validation-block"
                                             *ngIf="firstName?.touched && firstName?.errors"
                                             message="Please enter your first name.">

                </cl-error-validation-message>
                <div class="row">
                    <label for="last-name">Last Name</label>
                    <input id="last-name"
                           type="text"
                           class="full-row form-control"
                           formControlName="lastName" />
                </div>
                <cl-error-validation-message id="last-name-validation-message"
                                             class="validation-block"
                                             *ngIf="lastName?.touched && lastName?.errors"
                                             message="Please enter your last name">

                </cl-error-validation-message>
                <div class="row">
                    <label for="email">Email</label>
                    <input id="email"
                           type="email"
                           class="full-row form-control"
                           formControlName="email" />
                </div>
                <cl-error-validation-message id="email-validation-message"
                                             class="validation-block"
                                             *ngIf="email?.touched && email?.errors"
                                             message="Please enter your email in the following format: myname@domain.com">
                </cl-error-validation-message>
            </div>

            <div formGroupName="paymentDetails">

                <div class="row">
                    <label class="section-header">Payment Details</label>
                </div>

                <div class="row">
                    <label for="name-on-card">Name on Card</label>
                    <input id="name-on-card"
                           type="text"
                           class="full-row form-control"
                           formControlName="nameOnCard" />
                </div>
                <cl-error-validation-message id="name-on-card-validation-message"
                                             class="validation-block"
                                             *ngIf="nameOnCard?.touched && nameOnCard?.errors"
                                             message="Please enter your name as it appears on the credit card">
                </cl-error-validation-message>
                <div class="row">
                    <label for="credit-card-number">Debit or Credit Card Number</label>
                    <input id="credit-card-number"
                           type="text"
                           class="full-row form-control"
                           (keypress)="onKeyPressCreditCard($event)"
                           (input)="onCreditCardChange($event)"
                           formControlName="creditCardNumber" />
                </div>
                <cl-error-validation-message id="credit-card-number-validation-message"
                                             class="validation-block"
                                             *ngIf="creditCardNumber?.touched && creditCardNumber?.errors"
                                             message="Please enter a valid credit card number between 8-19 digits">

                </cl-error-validation-message>
                <div class="row" style="margin-left:-30px">
                    <div class="col-xs-5">
                        <label>Expiration Date</label>
                        <div class="row">
                            <div class="col-xs-5">
                                <input id="month"
                                       title="month"
                                       type="text"
                                       class="form-control"
                                       maxlength="2"
                                       (keypress)="onKeyPressDigitOnly($event)"
                                       style="width:50px"
                                       placeholder="MM"
                                       formControlName="month" />

                            </div>
                            <div class="col-xs-5">
                                <input id="year"
                                       title="year"
                                       type="text"
                                       class="form-control"
                                       maxlength="2"
                                       (keypress)="onKeyPressDigitOnly($event)"
                                       style="width:50px"
                                       placeholder="YY"
                                       formControlName="year" />
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-5">
                        <label>CVV</label>
                        <input id="cvv"
                               title="CVV"
                               type="text"
                               class="form-control"
                               maxlength="4"
                               (keypress)="onKeyPressDigitOnly($event)"
                               style="width:65px"
                               formControlName="cvv" />
                    </div>
                </div>
                <div class="validation-block">
                    <cl-error-validation-message id="month-validation-message"
                                                 *ngIf="month?.touched && month?.errors"
                                                 message="Please enter a valid month in the range 1-12">
                    </cl-error-validation-message>
                    <cl-error-validation-message id="year-validation-message"
                                                 *ngIf="year?.touched && year?.errors"
                                                 message="{{'Please enter a valid two-digit year greater than or equal to ' + current2DigitYear}}">
                    </cl-error-validation-message>
                    <cl-error-validation-message id="cvv-validation-message"
                                                 *ngIf="cvv?.touched && cvv?.errors"
                                                 message="{{'Please enter a valid ' + minCvv + '-digit or ' + maxCvv + '-digit CVV'}}">
                    </cl-error-validation-message>
                    <cl-error-validation-message id="expiration-message"
                                                 *ngIf="month?.touched && year?.touched && paymentDetails?.errors && paymentDetails?.errors.expired"
                                                 message="Please enter an expiration date greater than or equal to today">
                    </cl-error-validation-message>
                </div>
                <div class="row">
                    <label for="zip-code">Billing Zip Code</label>
                    <input id="zip-code"
                           type="text"
                           class="form-control"
                           maxlength="10"
                           (keypress)="onKeyPressZipCode($event)"
                           style="width:140px"
                           formControlName="zipCode" />
                </div>
                <cl-error-validation-message id="zip-code-validation-message"
                                             class="validation-block"
                                             *ngIf="zipCode?.touched && zipCode?.errors"
                                             message="Please enter a valid zip code in the following format: 12345 or 12345-1234">
                </cl-error-validation-message>
            </div>

            

            <div class="row">
                <p class="section-header">Final Amount to Be Charged</p>
            </div>
            <div class="row">
                <h1 id="total-amount-label" style="margin-top:0px">{{total | kendoNumber:'c'}}</h1>
            </div>
            <div class="row">
                <p id="total-amount-breakdown">The amount ensures that {{amount | kendoNumber:'c'}} is allocated to {{campaignInfo.studentName}}, with {{fees | kendoNumber:'c'}} going to sponsoring fees.</p>
            </div>
            <div style="display:inline-flex; margin-left:-15px;">

                <input id="policy-checkbox"
                       type="checkbox"
                       kendoCheckBox
                       style="margin-right:15px; width:30px;"
                       (keypress)="onKeyPressCheckbox($event)"
                       formControlName="termsAndConditions" />
                <label for="policy-checkbox">
                    By clicking this box you agree to the <a href="https://campuslogic.com/privacy-policy/" target="_blank">Privacy Policy</a>
                    and <a href="/termsandconditions" target="_blank">End User Agreement</a>
                </label>
            </div>

            <cl-error-validation-message id="policy-checkbox-validation-message"
                                         class="validation-block"
                                         style="margin-top:10px"
                                         *ngIf="this.termsAndConditions?.touched && this.termsAndConditions?.errors"
                                         message="Please accept the privacy policy and end-user agreement.">
            </cl-error-validation-message>

            <div class="row" *ngIf="submitClicked && !this.formGroup.valid">
                <hr />
                <span id="overall-validation-message"
                      class="fas fa-lg fa-exclamation-triangle form-required"
                      role="alert"
                      attr.aria-label="Please address the issues noted above."
                      style="font-size:14px">
                    &nbsp;&nbsp;Please address the issues noted above.
                </span>
                <hr />
            </div>

            <div class="row" style="margin-top: 20px">
                <button id="submit-button" class="btn btn-primary submit-button" (click)="submit()">Submit Gift</button>
            </div>

        </form>

        <div id="post-checkout-modal" *ngIf="makePaymentComplete">
            <div class="row" style="margin-top:30px">
                <p id="post-checkout-title" role="alert" style="font-size:large; font-weight: bold; text-align: center">{{giftConfirmedPrefix}}Thank you!</p>
            </div>
            <div class="row">
                <p id="post-checkout-message" role="alert" style="text-align: center; margin: 0 35px 0 35px">If you are interested in helping further, consider sharing this page or reading other important student stories.</p>
            </div>
            <div class="row" style="margin-top:30px">
                <button id="button-read-more" class="btn btn-primary submit-button" (click)="readMoreStoriesClick()">Read More Stories</button>
            </div>
                
                
            </div>

            <ss-make-payment-modal-component *ngIf="showMakePaymentModal" [payment]="payment" (closed)="makePaymentModalClosed($event)"></ss-make-payment-modal-component>

        </div>

    <!-- Diabled Overlay-->
    <div *ngIf="show" id="disabled-overlay" class="disabled-overlay show"></div>

</div>
